import { render, staticRenderFns } from "./AffinityCouponsListRoute.vue?vue&type=template&id=52dd1cbe&scoped=true&"
import script from "./AffinityCouponsListRoute.vue?vue&type=script&lang=js&"
export * from "./AffinityCouponsListRoute.vue?vue&type=script&lang=js&"
import style0 from "./AffinityCouponsListRoute.vue?vue&type=style&index=0&id=52dd1cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd1cbe",
  null
  
)

export default component.exports